import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-64a04f3c"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "page-container"
};
var _hoisted_2 = {
  class: "user-contest-table-box"
};
var _hoisted_3 = {
  class: "page-inner-container"
};
var _hoisted_4 = {
  class: "left-content"
};
var _hoisted_5 = ["src"];
var _hoisted_6 = {
  class: "user-name"
};
var _hoisted_7 = {
  class: "user-contest-tip"
};
var _hoisted_8 = {
  key: 0,
  class: "tip"
};
var _hoisted_9 = {
  key: 1,
  class: "tip"
};
var _hoisted_10 = {
  key: 0,
  class: "title"
};
var _hoisted_11 = {
  key: 1,
  class: "title"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_a_col = _resolveComponent("a-col");
  var _component_ContestTable = _resolveComponent("ContestTable");
  var _component_a_empty = _resolveComponent("a-empty");
  var _component_a_row = _resolveComponent("a-row");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_a_row, {
    type: "flex",
    gutter: 44,
    wrap: false
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_a_col, {
        flex: "188px"
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", null, [_createElementVNode("img", {
            class: "user-avatar",
            src: _ctx.userService.user && _ctx.userService.user.avatar
          }, null, 8, _hoisted_5)]), _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.userService.user && _ctx.userService.user.mobile), 1), _createElementVNode("div", _hoisted_7, [_ctx.isNocFlag ? (_openBlock(), _createElementBlock("div", _hoisted_8, "我的比赛")) : (_openBlock(), _createElementBlock("div", _hoisted_9, "我的活动"))])])];
        }),
        _: 1
      }), _createVNode(_component_a_col, {
        flex: "auto"
      }, {
        default: _withCtx(function () {
          var _a;
          return [_ctx.isNocFlag ? (_openBlock(), _createElementBlock("div", _hoisted_10, "我的比赛")) : (_openBlock(), _createElementBlock("div", _hoisted_11, "我的活动")), ((_a = _ctx.userExamService.userExamList) === null || _a === void 0 ? void 0 : _a.length) > 0 ? (_openBlock(), _createBlock(_component_ContestTable, {
            key: 2,
            list: _ctx.userExamService.userExamList
          }, null, 8, ["list"])) : _ctx.userExamService.total >= 0 ? (_openBlock(), _createBlock(_component_a_empty, {
            key: "key-empty",
            description: _ctx.isNocFlag ? '还未参加比赛' : '还未参加活动',
            style: {
              "margin": "100px 0",
              "font-size": "14px",
              "color": "#8f96a3"
            },
            image: _ctx.emptyImage,
            imageStyle: {
              height: '185px'
            }
          }, null, 8, ["description", "image"])) : _createCommentVNode("", true)];
        }),
        _: 1
      })];
    }),
    _: 1
  })])])]);
}